// External libs
import { createReducer } from '@reduxjs/toolkit'
// Interfaces
import { State } from '../interfaces'
// Actions
import actions from '../actions'

export const initialState: State = {
  open: false,
  orderId: 0,
  productId: 0,
  productName: '',
  selectedProduct: 0,
  refuseReason: '',
  refuseReasonsDescription: '',
}

export default createReducer(initialState, {
  [actions.clearAction.type]: state => clear(state),
  [actions.closeAction.type]: state => close(state),
  [actions.maximizeAction.type]: state => setOpen(state, true),
  [actions.openAction.type]: (
    state,
    {
      payload: {
        orderId,
        productId,
        productName,
        selectedProduct,
        refuseReason,
        refuseReasonsDescription,
      },
    },
  ) =>
    open(
      state,
      orderId,
      productId,
      productName,
      selectedProduct,
      refuseReason,
      refuseReasonsDescription,
    ),
})

const clear = (state: State) => {
  return initialState
}

const close = (state: State) => {
  state.open = false
  return state
}

const open = (
  state: State,
  orderId: number,
  productId: number,
  productName: string,
  selectedProduct: any,
  refuseReason: string,
  refuseReasonsDescription: string,
) => {
  state.open = true
  state.orderId = orderId
  state.productId = productId
  state.productName = productName
  state.selectedProduct = +selectedProduct
  state.refuseReason = refuseReason
  state.refuseReasonsDescription = refuseReasonsDescription
  return state
}

const setOpen = (state: State, open: boolean) => {
  state.open = open
  return state
}
